import React, { useState } from "react";
import { Layout, Typography } from "antd";
import Sidebar from "components/Sidebar";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { axiosIntercept } from "http/axiosIntercept";
import { IDomainsConfig } from "pages/Ponds/types";
import CombinedGroupForm from "components/AccessGroupForm/CombinedGroupForm";

const { Title } = Typography;
const fullWidth = 300;

const AccessGroupsPage: React.FC = () => {
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
    const msalInstance = useMsal();
    axiosIntercept(msalInstance);

    const handleDomainSelect = (domain: IDomainsConfig) => {
        navigate(`/explorer/${domain.display_name}`);
    };

    return (
        <Layout style={{ marginLeft: collapsed ? 80 : fullWidth }}>
            <Sidebar
                collapsed={collapsed}
                selectedDomainKey="access-groups"
                onCollapse={setCollapsed}
                onDomainSelect={handleDomainSelect}
            />
            <Layout>
                <div
                    style={{
                        marginTop: 64,
                        padding: "24px 32px",
                        minHeight: "calc(100vh - 64px)",
                        background: "#f5f5f5",
                    }}
                >
                    <div
                        style={{
                            position: "sticky",
                            top: 64,
                            zIndex: 4,
                            background: "#f5f5f5",
                            paddingTop: 8,
                            paddingBottom: 8,
                            marginBottom: 8,
                        }}
                    >
                        <Title level={4} style={{ marginBottom: 0 }}>
                            Access Groups
                        </Title>
                    </div>

                    <CombinedGroupForm />
                </div>
            </Layout>
        </Layout>
    );
};

export default AccessGroupsPage;
